module.exports = __webpack_public_path__ + "img/game_img4.236acd40.jpg";